import React from 'react';

function ComingSoonPage({ title, description }) {
  return (
    <>
      <header className="admin-dashboard__header">
        <div>
          <h1 className="admin-dashboard__title">{title}</h1>
          <p className="admin-dashboard__subtitle">{description}</p>
        </div>
      </header>

      <div className="admin-dashboard__card admin-coming-soon">
        <div className="admin-coming-soon__badge">Coming Soon</div>
        <p className="admin-coming-soon__copy">
          This section is part of the admin roadmap and will be built out as the platform grows.
        </p>
      </div>
    </>
  );
}

export default ComingSoonPage;
